import { Component, OnInit, Output, EventEmitter, Renderer2 } from '@angular/core';
import templateString from './taskAccumulationTypeChangeOrder.component.html';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { HttpClient } from '@angular/common/http';

@Component({
  standalone: false,
  template: templateString, host: {'forUniqueComponentId': 'adsfasfeaee33'}
})
export class TaskAccumulationTypeChangeOrderComponent implements OnInit {
    @Output() action = new EventEmitter();
    
    public originalTaskAccumulationTypes: any;
    
    public taskAccumulationTypes: any;

    constructor(
        private http: HttpClient,
        private bsModalRef: BsModalRef,
        private renderer: Renderer2
    ) { 
        this.renderer.addClass(document.body, 'md-skin');
		this.renderer.addClass(document.body, 'landing-page');
		this.renderer.addClass(document.body, 'fixed-nav');
    }

    ok() {
        this.http.post("task_accumulation_types/update_order", { task_accumulation_type_ids: this.taskAccumulationTypes.map(function(x) { return x.id; }) }).subscribe(() => {
            this.action.emit(true);
            this.bsModalRef.hide();
		});
    }

    cancel() {
        this.bsModalRef.hide();
    };

    drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(this.taskAccumulationTypes, event.previousIndex, event.currentIndex);
    }

    ngOnInit() {
        this.taskAccumulationTypes = JSON.parse(JSON.stringify(this.originalTaskAccumulationTypes));
    }
}
